const buttonTexts = [
  "Let's Go",
  "Get Started",
  "Make Contact",
  "Seal the Deal",
  "Reach Out Now",
  "Take the Lead",
  "Connect Now",
  "Grab It Now",
  "Act Fast ⚡",
  "Engage Lead",
  "Grab It",
  "Act Now",
  "Don’t Miss Out",
  "Seal the Deal",
  "Win This Lead",
  "Take Action",
  "Connect Now",
  "Call Today",
  "Let’s Close This 🚀",
  "Convert It",
  "Chase the Win",
  "Your Deal Awaits",
  "Make It Yours",
  "Catch This Lead",
  "Hot Prospect 🔥",
  "Time to Close",
  "Next Big Client",
  "Turn It Into Gold",
  "Follow Up Fast",
  "Strike Now ⚡",
  "Proceed to Connect",
  "Engage Lead",
  "Initiate Contact",
  "Schedule Call",
  "Start Conversation",
  "Reach Out",
  "Move Forward",
  "Continue Journey",
  "Build Relationship",
  "Convert to Client",
];

const newLeadAlerts = [
  "🎉 New lead just arrived! Act quickly to connect first.",
  "🚀 Fresh opportunity in the pipeline — don’t miss out!",
  "⚡ A hot prospect is waiting for you right now.",
  "📞 Be the first to call — close it faster!",
  "🔥 New enquiry landed — time to take action!",
  "🚀 New lead alert!\nBe the first to connect.\nDeals don’t wait!",
  "⚡ A fresh enquiry just landed!\nReach out now.\nSuccess favors speed.",
  "🔥 Hot prospect incoming!\nYour next big client?\nMake the call today.",
  "✨ Someone’s interested in us!\nEvery hello is an opportunity.\nStart the conversation now.",
  "🤝 A potential client awaits!\nStrong starts lead to strong deals.\nPick up the phone.",
  "📢 Enquiry received!\nThey chose us for a reason.\nLet’s prove them right.",
  "🎯 Fresh opportunity unlocked!\nPipeline just got stronger.\nKeep the wins coming.",
  "📞 New contact on the list!\nConnections create conversions.\nCall. Close. Celebrate.",
  "💼 Business knocking!\nEvery lead is a new door.\nOpen it with confidence.",
];
const greetingWithNames = [
  "Hey, Sales Champ 🚀",
  "Hi, Deal Maker 💼",
  "Hello, Lead Hunter 🎯",
  "Heya, Closer Pro 🔑",
  "Yo, Target Crusher 💥",
  "Hiya, Growth Driver 📈",
  "Hola, Revenue Star 🌟",
  "Greetings, Opportunity Ace 🏆",
  "Hey there, Pipeline Hero 🦸",
  "Hi, Client Magnet 🧲",
  "Yo, Conversion Master 👊",
  "Hey, Quota Crusher ⚡",
  "Hello, Deal Wizard 🪄",
  "Hi, Funnel Master 🔥",
  "Heya, Customer Champion ❤️",
  "Hello, Success Driver 🚗",
  "Hi, Prospect Guru 📊",
  "Yo, Profit Hunter 🐅",
  "Hey, Growth Hacker 🕶️",
  "Greetings, Number Slayer 🔢",

  // 🔥 New Additions
  "Hey, Lead Slayer ⚔️",
  "Hi, Deal Dynamo 💡",
  "Hello, Target Hero 🛡️",
  "Heya, Opportunity Slayer 🗡️",
  "Yo, Revenue Driver 🚀",
  "Hiya, Pipeline Master 🔧",
  "Hola, Client Hero 🤝",
  "Greetings, Conversion Ace 🥇",
  "Hey there, Growth Warrior 🦾",
  "Hi, Success Maker ✨",
  "Yo, Prospect Slayer 🎯",
  "Hey, Deal Closer ⚒️",
  "Hello, Opportunity Builder 🧱",
  "Hi, Funnel Hero 🌀",
  "Heya, Sales Driver 🏎️",
];

module.exports = {
  buttonTexts,
  newLeadAlerts,
  greetingWithNames,
};
